import { BigNumberSupport } from "./ListBigNumber";

interface Props {
    toogle: () => void;
    title: string;
    description: string;
    type:  BigNumberSupport;
    total: number;
    active:  BigNumberSupport;
}

const BigNumberCard = ({ title, total, type, toogle, description, active }: Props) => {
    const getColor = () => {
        const bg = {
            "IN_ANALYSIS": 'bg-rating-2',
            "ANSWERED": 'bg-rating-2',
            "OPEN": 'bg-dark',
            "FINISHED": 'bg-status-available'
        }
        return bg[type as keyof typeof bg] || 'bg-dark';
    };

    const getBorderColor = () => {
        if (active === type) {
            return 'border-color-primary'
        }
        return ''
    };

    return (
        <div  style={{height: 128, padding: '24px 0px'}} className={`panel panel-default panel-body panel-blank shadow-default padding-x-0 margin-bottom-0 position-relative cursor-pointer width-100pct border ${getBorderColor()}`} onClick={toogle}>
            <div className="position-relative width-100pct height-100pct padding-x-25">
                <div className="text-size-20 text-medium text-color-dark">{title}</div>
                <div className="text-bold text-color-dark" style={{ fontSize: 24 }}>{total}</div>
                <span className={`position-absolute left--1 top-0 height-100pct width-3 ${getColor()}`} />
                <div className="text-size-14 text-normal line-height-100pct text-color-dark">{description}</div>
            </div>
        </div>
    )
}

export default BigNumberCard;